import React, { useEffect } from "react";
import PropTypes from "prop-types";

import Constants from "../../assets/data/constants";
// import cx from "classnames";
// import startIcon from "../../assets/img/startIcon.svg";

import "./learning-card.scss";
import "./learning-card.responsive.scss";

const LearningCard = (props) => {
  const { placement, bgColor, data, relApps, bgOffset, btnText } = props;
  let folderName = '';

  const [dimensions, setDimensions] = React.useState({
    height: window.innerHeight,
    width: window.innerWidth
});

useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
        setDimensions({
          height: window.innerHeight,
          width: window.innerWidth
        });
      }, 1000);
  
      window.addEventListener("resize", debouncedHandleResize);
  
      return _ => {
        window.removeEventListener("resize", debouncedHandleResize);
      };
});

function debounce(fn, ms) {
    let timer;
    return _ => {
      clearTimeout(timer);
      timer = setTimeout(_ => {
        timer = null;
        fn.apply(this, arguments);
      }, ms);
    };
}

if (dimensions.width > 320 && dimensions.width < 768) {
  folderName = 'mob';
} else if (dimensions.width > 767 && dimensions.width < 1170) {
  folderName = 'ipad';
} else if (dimensions.width > 1169 && dimensions.width < 1700) {
  folderName = '1280';
} else {
  folderName = '1920';
}

  const startLearning = (e) => {
    // e.preventDefault();
    // const windowWidth = window.innerWidth;
    // const windowHeight = window.innerHeight;
    // const width = Math.max(windowWidth - Constants._POPUP_OFFSET * 2, Constants._POPUP_MIN_SIZE);
    // const height = Math.max(windowHeight - Constants._POPUP_TOP_OFFSET, Constants._POPUP_MIN_SIZE);
    // const top = Math.max(0, windowHeight - height);
    // const left = Math.max(0, (windowWidth - width)/2);
    // const toolbar = 'no';
    // const features = `width=${width},height=${height},left=${left},top=${top}`;
    // window.open(data.link, Constants._LEARNING_WINDOW_NAME,  'width=720,height=800,toolbar=0,location=0, directories=0, status=0, location=no, menubar=0')
  
    let launchWindow;
    launchWindow = open(data.link, 'launchWindow');
    launchWindow.focus();
  };


  const content = [
    <div className="column imgWrapper lg-only" key="imgWrapper">
      <img src={`./static/img/lp_thumbs/${folderName}/${data.thumb}`} className="lp-image"/>
    </div>,
    // <div className="contentWrapper" key="contentWrapper" style={{ height: data.height }}>
    <div className="column contentWrapper" key="contentWrapper" >
      {/* <span className="title">{data.title}</span> */}
      <span className="title" dangerouslySetInnerHTML={{__html: data.title}}></span>
      <section className="description">
        {data.description.map((block, index) => (
          <p key={`desp-block-${index}`} dangerouslySetInnerHTML={{__html: block}}></p>
        ))}
      </section>
      <div className="btnWrapper lg-only">
        <div role="button" className="btn" onClick={startLearning}>
          <img src="./static/img/startIcon.svg" alt="start arrow" />
          <span>{btnText}</span>
        </div>
      </div>
      <div className="relApp-div lg-only">
          <span className="relApp">Related Applications:</span>
          <div className="app-list">
            {relApps.map((obj, index) => (
              <span style={{display: 'flex'}}>
                  <img src={`./static/img/app_icons/${folderName}/${obj.icon}`} style={{alignSelf: 'center'}}/>
                  <span className="app-class">{obj.app}</span>
              </span>
            ))}
          </div>
      </div>
    </div>
  ];
  
  const deviceBtn = (
    <div className="btnWrapper device-only">
      <div role="button" className="btn" onClick={startLearning}>
        <img src="./static/img/startIcon.svg" alt="start arrow" />
        <span>{btnText}</span>
      </div>
    </div>
  );

  const deviceRelApp = (
    <div className="relApp-div device-only">
    <span className="relApp">Related Applications:</span>
    <div className="app-list">
      {relApps.map((obj, index) => (
        <span style={{display: 'flex'}}>
            <img src={`./static/img/app_icons/${folderName}/${obj.icon}`} style={{alignSelf: 'center'}}/>
            <span className="app-class">{obj.app}</span>
        </span>
      ))}
    </div>
</div>
  );

  if (placement === "left") {
    Array.prototype.reverse.apply(content);
    // Array.prototype.reverse.apply(cont);
  }

  // const bgStyle = {
  //   [placement]: 0,
  //   bottom: bgOffset,
  // };

  return (
    <div className="learning-card" style={{ backgroundColor: bgColor }}>
      {content}
      {deviceBtn}
      {deviceRelApp}
    </div>
  );
};

LearningCard.propTypes = {
  placement: PropTypes.oneOf(["left", "right"]),
  // bgTitle: PropTypes.string,
  bgColor: PropTypes.string,
  btnText: PropTypes.string,
  bgOffset: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    description: PropTypes.arrayOf(PropTypes.string),
    link: PropTypes.string,
    thumb: PropTypes.string,
    height: PropTypes.string
  }),
  relApps: PropTypes.array
  // relApps: PropTypes.arrayOf(
  //   PropTypes.shape({
  //     icon: PropTypes.string,
  //     app: PropTypes.string
  //   })
  // )
};

LearningCard.defaultProps = {
  bgPlacement: "center",
  bgColor: "#fff",
  bgOffset: 0,
  btnText: 'Start learning'
};

export default LearningCard;
